// extracted by css-extract-rspack-plugin
export default {"Header":"zQn2C","HeaderButton":"ESKGM"};